module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","dataEntry":"Datenerfassung","values":"Werte","ranking":"Ranking"},"en":{"back":"Back","dataEntry":"Data entry","values":"Values","ranking":"Ranking"}}')
  delete Component.options._Ctor
}
